import { useCallback, useState } from "react";
import { ReactSVG } from "react-svg";

// UI
import { Button } from "ui/components/Button/Button";
import VehicleTransferEditCard from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleTransferEditCard/VehicleTransferEditCard";

// Servisni sloj
import { VEHICLE_LOCATION_TYPE_CONFIG } from "services/api/fleet/vehicles/locations/consts";
import { VehicleLocation as VehicleLocationType } from "services/api/fleet/vehicles/locations/types";
import { FleetVehicleStatusEnum } from "services/api/fleet/vehicles/types";

import { VehicleLocationProps } from "./types";

/**
 * Trenutna lokacija vozila uz akciju premještaja. Vozila unesena prije uvođenja lokacija
 * je nemaju — tada se nudi samo premještaj.
 */
const VehicleLocation: React.FC<VehicleLocationProps> = (props) => {
    const { fleetVehicleDetail, onLocationChange, onStatusChange } = props;

    const [showTransferModal, setShowTransferModal] = useState<boolean>(false);

    const location = fleetVehicleDetail.location;
    const vehicleId = fleetVehicleDetail.id;

    const handleTransferClick = useCallback(() => {
        setShowTransferModal(true);
    }, []);

    const handleTransferClose = useCallback(() => {
        setShowTransferModal(false);
    }, []);

    const handleTransferSuccess = useCallback(
        (saved: VehicleLocationType) => {
            onLocationChange?.(saved);
        },
        [onLocationChange]
    );

    const handleTransferStatusChange = useCallback(() => {
        onStatusChange?.();
    }, [onStatusChange]);

    if (!vehicleId) return <></>;

    const typeLabel = location?.locationType
        ? VEHICLE_LOCATION_TYPE_CONFIG[location.locationType]?.label
        : null;

    return (
        <>
            <div className="flex items-center gap-2 px-4 pt-3 text-md">
                <div>
                    <div className="w-10 h-10 bg-sky-100 rounded-full flex items-center justify-center">
                        <ReactSVG
                            src="/media/icons/location.svg"
                            className="flex items-center justify-center [&_svg]:w-5 [&_svg]:h-5 text-sky-500"
                        />
                    </div>
                </div>
                <div className="flex-1">
                    <div className="flex justify-between items-center">
                        <div className="flex gap-1">
                            <div className="text-slate-600">Trenutna lokacija:</div>
                            <div className="text-slate-900 font-medium">
                                {location?.locationName ?? "Nije određena"}
                            </div>
                            {typeLabel && (
                                <div className="text-slate-400">({typeLabel})</div>
                            )}
                        </div>
                        <Button
                            size="small"
                            variant="warning"
                            startIcon="/media/icons/location.svg"
                            onClick={handleTransferClick}
                        >
                            Premjesti vozilo
                        </Button>
                    </div>
                </div>
            </div>

            <VehicleTransferEditCard
                show={showTransferModal}
                vehicleId={vehicleId}
                currentLocation={location}
                currentStatus={fleetVehicleDetail.status as FleetVehicleStatusEnum | null}
                onClose={handleTransferClose}
                onSuccess={handleTransferSuccess}
                onStatusChange={handleTransferStatusChange}
            />
        </>
    );
};


export default VehicleLocation;
